import { BmExpensesCalcService } from "../../expenses/bm-expenses-calc.service";
import { BmTotalAccumulatedCapCalcService } from "../../total/accumulated/bm-total-accumulated-cap-calc.service";
import { FormGroup } from "@angular/forms";
import { BmExpFg, BmExpGroupFg, BudgetModelFormGroup } from "../../../pojo/bm-form";
import { BmTotalGeneralCalcService } from "../../total/general/BmTotalGeneralCalcService";
import { BmSubscriptionsInvestmentHelperService } from "./bm-subscriptions-investment-helper.service";

export class BmSubscriptionsExpensesHelperService {

  /**
   * Recalculate all expenses related values
   * - group items
   * - group row
   * - section total
   *
   * - total Capital Required
   * - total accumulated required
   */
  static recalculateRelatedValues(expGroupFg: FormGroup<BmExpGroupFg>, expForm: FormGroup<BmExpFg>, budgetForm: BudgetModelFormGroup): void {
    BmExpensesCalcService.recalculateGroup(expGroupFg);
    BmExpensesCalcService.recalculateGroupRowTotal(expGroupFg);
    BmExpensesCalcService.recalculateSectionTotal(expForm);

    BmTotalGeneralCalcService.recalculateTotalExpenses(budgetForm, budgetForm.controls.modelData.controls.totalExpenses, false);
    BmSubscriptionsInvestmentHelperService.recalculateInvestmentValue(budgetForm);
    BmTotalGeneralCalcService.recalculateTotalExpenses(budgetForm, budgetForm.controls.modelData.controls.totalCapRequired, true);
    BmTotalGeneralCalcService.recalculateAllRowValuePcnt(budgetForm);
    BmTotalAccumulatedCapCalcService.recalculateTotalAccumulatedRequired(budgetForm);
  }
}
